import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, View } from '../../components';
import './style.scss';

const WithdrawalSuccess = () => {
    const navigate = useNavigate();

    return (
        <View>
            <div className='withdrawalSuccessPage'>
                <p style={{fontSize: '35px', marginTop: '0px', marginBottom: '40px', fontWeight: '900'}}>
                    <span className='welcomeUnderline'>Withdrawal</span> Requested
                </p>
                <Button onClick={() => navigate('/overview')}>
                    View Portfolio
                </Button>
            </div>
        </View>
    );
};

export default WithdrawalSuccess;
